<template>
  <gg-card>
    <gg-card-header>
      Choose Your Layout
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <p>
            Select the layout to use as the starting point for your website.
          </p>
          <v-item-group v-model="theme" mandatory>
            <v-row>
              <v-col v-for="(item, i) in secondStep.themes" :key="i" cols="12" md="3">
                <v-item v-slot="{ active, toggle }" :value="item.key">
                  <v-card class="app-card" @click="toggle">
                    <v-card-text class="text-center pa-0"
                                 :style="active ? 'border: 2px solid #0ca750 !important' : ''">
                      <v-img :src="themeImage(item.key)"
                             position="top"
                             height="860"
                             max-height="860"
                             class="d-flex align-center ma-auto">
                      </v-img>
                      <gg-btn block
                             tile
                             :color="active ? 'primary' : 'white'"
                             :href="item.url"
                             target="_blank"
                             @click.stop>
                        Visit Demo Site
                      </gg-btn>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-item-group>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { themeImage } from 'Helpers/wizard'

export default {
  name: 'Theme',
  computed: {
    ...mapGetters({
      secondStep: 'wizard/second_step',
      storeTheme: 'wizard_model/theme',
    }),
    theme: {
      get () {
        return this.storeTheme
      },
      set (val) {
        this.setTheme(val)
      }
    },
  },
  methods: {
    ...mapMutations({
      setStep: 'wizard/SET_STEP',
      setTheme: 'wizard_model/SET_THEME',
    }),
    themeImage,
    validate () {
      return true
    }
  },
}
</script>
